import { gql } from '@efficiently/client-core-graphql-models';

export const DELETE_CONTENTS = gql(`
	mutation DeleteContents($ids: [String!]!) {
		deleteContents(ids: $ids)
	}
`);
